import React from 'react';
import { CustomPicker } from 'react-color';
import { EditableInput, Hue, Saturation } from 'react-color/lib/components/common';

import { css } from '@emotion/core';

const Wrapper = css`
  .hue {
    height: 75px;
    position: relative;
  }

  .saturation {
    height: 200px;
    position: relative;
  }
`;

export const MyPicker = props => {
  const styles = {
    input: {
      height: 34,
      border: `2px solid ${props.hex}`,
      borderRadius: '5px',
      textAlign: 'center',
      paddingLeft: 10,
    },
  };
  return (
    <div css={Wrapper}>
      <div className="hue">
        <Hue hsl={props.hsl} onChange={props.onChange} />
      </div>

      <h2 style={{ marginTop: '5rem' }}>You can tweak the saturation and lightness...</h2>
      <div className="saturation">
        <Saturation {...props} onChange={props.onChange} />
      </div>

      <h2 style={{ marginTop: '5rem' }}>You can also directly paste your color's HEX value...</h2>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <EditableInput
          style={{ input: styles.input }}
          value={props.hex}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
};

export default CustomPicker(MyPicker);
